export const ARTICLE_TYPE_SERVICE = 'services'
export const ARTICLE_TYPE_GOODS = 'goods'
